import { axiosV4 } from "../../../Utils/Axios/axiosV4";
export const buyExamPdfService = async (
  userToken: string,
  pdfId: string | number,
  payWithWallet: number,
  payWithGiftWallet: number,
) => {
  const data = new FormData();
  data.append("sample_exam_pdf_id", String(pdfId));
  data.append("pay_with_wallet", String(payWithWallet));
  data.append("pay_with_gift_wallet", String(payWithGiftWallet));
  return axiosV4.post("user/sample-exams/buy-pdf", data, {
    headers: {
      Authorization: `Bearer ${userToken}`,
    },
  });
};
